import { useQuery } from '@tanstack/react-query'

import { useGamificationDataStore } from '@/shared/store/gamificationDataStore'

import { fetchNetworkingDeclaration } from './api'
import { selectVocabulary } from './diff'

import type { NetworkingTag } from './types'

export const networkingDeclarationKey = (digitalProductId: string | number) => [
  'networking-declaration',
  String(digitalProductId)
]

/**
 * A declaração é server-authoritative, então vive em react-query — não no store
 * do zustand, que guarda a configuração do evento.
 */
export const useNetworkingDeclarationQuery = (
  digitalProductId: string | number | null | undefined
) =>
  useQuery({
    queryKey: networkingDeclarationKey(digitalProductId ?? ''),
    queryFn: () => fetchNetworkingDeclaration(digitalProductId as string | number),
    enabled: !!digitalProductId,
    refetchOnWindowFocus: false
  })

/**
 * Vocabulário ativo do evento, lido do payload de dados já em cache no store —
 * sem requisição própria.
 */
export const useNetworkingVocabulary = (): NetworkingTag[] =>
  useGamificationDataStore(state => selectVocabulary(state.getActiveProductData()))
